<template>
  <employee-select
    v-model="_value"
    class="w-full bg-white shadow-sm rounded"
    :options="options"
    :disabled="disabled"
    :allow-any="allowAny"
    :allow-none="allowNone"
    :service="service"
    :availability-options="availabilityOptions"
    :preselect="preselect"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useServiceStore } from '~/stores/useServiceStore'
import { useEmployeeStore } from '~/stores/useEmployeeStore'

import EmployeeSelect from '@/components/employee/elements/Select.vue'

interface Props {
  modelValue?: any
  disabled?: boolean
  allowAny?: boolean
  allowNone?: boolean
  service?: Record<string, any> | null
  resource?: Record<string, any> | null
  availabilityOptions?: Record<string, any> | null
  preselect?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  disabled: false,
  allowAny: false,
  allowNone: false,
  service: null,
  resource: null,
  availabilityOptions: null,
  preselect: true,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
  (e: 'change', value: any): void
}>()

const serviceStore = useServiceStore()
const employeeStore = useEmployeeStore()

const services = computed(() => serviceStore.all)
const employees = computed(() => Array.isArray(employeeStore.all) ? employeeStore.all : [])

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
    emit('change', value)
  },
})

const _service = computed(() => {
  const service = props.service

  return services.value
    .find(({ idService }: any) => idService === service?.idService || service?.service?.idService)
})

const options = computed(() => {
  const { resource } = props
  const emps = employees.value

  const ids = resource?.serviceResource?.resourceIDs

  if (ids) {
    const filtered = emps
      .filter((employee: any) => {
        return ids.includes(employee.idEmployee)
      })

    return filtered
  }

  return null
})
</script>
